import { useEffect, useState, useMemo } from "react";
import ReactTableWrapper from "../../components/ReactTableWrapper";
import { exportAsCSV } from "../../utils/CSVExporter";
import { exportAsPDF } from "../../utils/PDFExporter";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import ListFormPageHeader from "../../components/ListFormPageHeader";
import Sidebar from '../../Sidebar';
import Swal from "sweetalert2";
import { useCookies } from 'react-cookie';
import { displayError,parseBoolean } from "../../helpers";
import { getAllSalesRepresentatives, deleteSalesRepresentative } from "../../services/SalesRepresentativeServices";
function SalesRepresentativeTable() {
    const InitialData = {
        total_pages: 0,
        records: [],
      };
    const [data, setData] = useState(InitialData);
    const navigate = useNavigate(); 
    const [refreshKey, setRefreshKey] = useState(0);
    const [cookies] = useCookies(['myToken']);
    const [isLoading, setIsLoading] = useState(true);  
    const columns = useMemo(
        () => [
            {
                fieldName: 'entity_name', 
                headerName: 'Sales Representative Name'
            },
           
            {
                fieldName: "address",
                headerName: 'Address'
            },
            {
                fieldName: "phone_number",
                headerName: 'Phone Nos'
            },
            {
                fieldName: "mobile_number",
                headerName: 'Mobile Nos'
            },
            {
                fieldName: 'status',
                headerName: 'Status',
            },
            {
                fieldName: "id",
                headerName: "ROW_ACTIONS"
            }
        ],
        [],);

    const editSalesrep = (salesRepId, event) => {
       
       navigate(`/SalesRepEdit/${salesRepId}/`);
    };

    const deleteSalesrep = (salesrepId, event) => {

        event.preventDefault();
        Swal.fire({title: 'Are you sure to Delete?',  
        showCancelButton: true,  
        confirmButtonText: `Yes`,  
        cancelButtonText: `No`,
        }).then((result) => {  
          if (result.isConfirmed) { 

            setIsLoading(true);
            deleteSalesRepresentative(cookies, salesrepId)
            .then(response => {
                console.log(`SalesRep with id ${salesrepId} deleted`);
                Swal.fire('Deleted Successfully!', '', 'success');
                setRefreshKey(oldKey => oldKey +1)
            })
            .catch(error => {
                setRefreshKey(oldKey => oldKey +1);
                console.log(error.response.data);
                displayError(error.response.data,'Delete Failed');
            });  
            
          } else if (result.isDismissed) {    
            Swal.fire('Not Deleted', '', 'info')  
        }
        });
        //

    };

    const handleCSVExport = (event) => {
        console.log('CSV Export');
        exportAsCSV(
            columns
            .filter(col => col.headerName !== 'ROW_ACTIONS')
            .map(c => c.headerName),
            data.records.map(r => {

                const csvRow = {
                    entity_name: r.entity_name,
                    address: r.address,
                    phone_number:r.phone_number,
                    mobile_number:r.mobile_number,
                    status:r.status
                }
                return csvRow;
                }));
    };

    const handlePDFExport = (event) => {
        console.log('PDF Export');
        exportAsPDF(
            'List of Sales Representatives',
            columns
            .filter(col => col.headerName !== 'ROW_ACTIONS')
            .map(col=>({header: col.headerName, dataKey: col.fieldName })),
            data.records.map(r => ({
                entity_name: r.entity_name,
                address: r.address, 
                phone_number:r.phone_number,
                mobile_number:r.mobile_number,
                status:r.status
            })),
            'Sales_Reps.pdf'
        );
    };

    useEffect(() => {

        getAllSalesRepresentatives(cookies)
        .then( salesRepList => {
            const tableData = salesRepList.salesrep_data
            .map(salesrep => ({
                entity_name: salesrep.entity_name,
                address: `${salesrep.address_1},\n${salesrep.address_2},\n${salesrep.address_3}`,
                phone_number:salesrep.phone_number,
                mobile_number:salesrep.mobile_number,
                status:salesrep.status? "Active":"Inactive",
                id: salesrep.id,    
            }));

            setData({
                total: data.total,
                records: tableData
            });
            setIsLoading(false);
        });
        }, [refreshKey]);
    
    return (

        <div id="outer-container"  className="App" > 
            <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
            <div id="page-wrap">
            <ListFormPageHeader module="ADMIN" title="List of Sales Representatives" formLink="/SalesRep" addNewLabel="New Sales Representative" />
                <div className="container item-list-table-container">
                <div className="table-responsive">
                <ReactTableWrapper
                            title='List of Sales Representatives'
                            columns={columns}
                            data={data.records}
                            onRowEdit={editSalesrep}
                            onRowDelete={deleteSalesrep}
                            onCSVExport={handleCSVExport}
                            onPDFExport={handlePDFExport}
                            isLoading={isLoading}
                        />
                </div>
                </div> 


            </div>
            <button style={{position:"relative",right:"40px"}}className="btn btn-fill btn-primary float-end" type="button" onClick={() =>{navigate("/SalesRep")}}>Back</button>
        </div>

        
    );

}



export default SalesRepresentativeTable;